import type { RouteObject } from "react-router-dom";

export const ccClientHealthRoutes: RouteObject[] = [
  {
    handle: { breadcrumb: "CC client health" },
    async lazy() {
      const { Page } = await import("../app/page");
      return { element: <Page hidePadding={() => true} /> };
    },
    children: [
      {
        index: true,
        async lazy() {
          const { CcClientHealthPage } = await import(
            "./cc-client-health-page"
          );
          return { Component: CcClientHealthPage };
        },
      },
    ],
  },
];
